// app/javascript/entrypoints/controllers/range_slider_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "hiddenInput", "valueDisplay"]
  static values = { 
    ranges: Array,
    rangeLabels: Object
  }

  connect() {
    this.updateValue()
  }

  updateValue() {
    const selectedIndex = parseInt(this.sliderTarget.value)
    const selectedRange = this.rangesValue[selectedIndex]
    
    // Mettre à jour l'input caché
    this.hiddenInputTarget.value = selectedRange
    
    // Mettre à jour l'affichage
    this.valueDisplayTarget.textContent = this.rangeLabelsValue[selectedRange]
  }
}